import { render, staticRenderFns } from "./NUM2BANKProviderChart.vue?vue&type=template&id=7810cea6&"
import script from "./NUM2BANKProviderChart.vue?vue&type=script&lang=js&"
export * from "./NUM2BANKProviderChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports